import { AddonDownload } from "./modules/addon-download";
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.ac-addon').forEach(element => {
        new AddonDownload(element, element.dataset.slug);
    });
});
